import { DesignData, ElementAddress, MediaText } from 'editor/src/store/design/types';

export interface CustomFontTextTarget {
  element: MediaText;
  address: ElementAddress;
}

/**
 * Walks a DesignData tree and returns every text element whose font is a
 * custom-uploaded font (family prefixed with `custom-`), along with the address
 * needed to dispatch updates back into that element.
 *
 * Used by the product personalizer to drive the custom-font render orchestrator
 * (one server-side path fetch per custom-font text element) independently of
 * which preview component is currently mounted — so mobile rasterized previews
 * pick up the same fresh paths the desktop overlay uses.
 */
const getCustomFontTextTargets = (designData: DesignData | undefined): CustomFontTextTarget[] => {
  if (!designData) {
    return [];
  }
  const targets: CustomFontTextTarget[] = [];
  designData.spreads.forEach((spread, spreadIndex) => {
    spread.pages.forEach((page, pageIndex) => {
      page.groups.media?.forEach((element, elementIndex) => {
        if (element.type === 'text' && element.extra?.fontFamily?.startsWith('custom-')) {
          targets.push({ element, address: { spreadIndex, pageIndex, elementIndex } });
        }
      });
    });
  });
  return targets;
};

export default getCustomFontTextTargets;
